import {regMobile} from "@/util/util";


export default {
    data() {
        return {
            mobile: '',
            password: '',
            reg_password: '',
            input_type1: true,
            input_type2: true,
            invite: '',
            code: '',
            disabled: true,
            codeText: '获取验证码',
        }
    },

    created() {

    },

    methods: {

        changePassword() {
            if(!regMobile(this.mobile)) {
                this.$message.error('请输入正确的手机号！')
                return;
            }
            if(!this.code) {
                this.$message.error('请输入验证码！')
                return;
            }
            if(!this.password.trim()) {
                this.$message.error('请输入密码！')
                return;
            }
            if(!this.reg_password.trim()) {
                this.$message.error('请输入确认密码！')
                return;
            }
            if(this.password !== this.reg_password) {
                this.$message.error('两次密码输入一致，请重新输入！')
                return;
            }

            this.$post('api.php/Index/findPassword',{
                mobile: this.mobile,
                code: this.code,
                password: this.password,
                rePassword: this.reg_password
            }).then(res => {

                if(res.status == 1) {
                    this.$message.success(res.info)
                    this.mobile = '';
                    this.code = '';
                    this.password = '';
                    this.reg_password = '';
                    this.$parent.$parent.closeMask();
                }else {
                    this.$message.error(res.info)
                }
            })

        },


        // 获取验证码
        getCode() {
            if(!regMobile(this.mobile)) {
                this.$message.error('请输入正确的手机号！')
                return;
            }
            if(this.disabled) {
                this.$post('api.php/Index/sendCode',{
                    type: 2,
                    mobile: this.mobile
                }).then(res => {

                    if(res.status == 1) {
                        this.$message.success(res.info);
                        this.disabled = false;
                        let second = this.$second;
                        this.codeText = second + 's';
                        this.timer = setInterval(() => {
                            second--;
                            if (second >= 0) {
                                this.codeText = second + 's'
                            }else {
                                clearInterval(this.timer);
                                this.codeText = '重新获取';
                                this.disabled = true;
                            }
                        },1000);
                    }else {
                        this.$message.info(res.info);
                    }
                })


            }
        },

        close() {
            this.$emit('close');
        }
    }
}
